import {useState} from 'react';
import './CheatSheet.css';
import condaSheet from './data/conda.json';
import gitSheet from './data/git.json';
import httpStatusCodes from './data/http_status_codes.json';
import kubectlSheet from './data/kubectl.json';
type CheatSheetDataItem = {
	description: string;
	command: string;
	category: string;
};
type CheatSheetData = {
	button: string;
	title: string;
	officialDocumentation: string;
	items: CheatSheetDataItem[];
};
export const CheatSheet = () => {
	const sheets = [condaSheet, gitSheet, kubectlSheet, httpStatusCodes];
	const [search, setsearch] = useState<string>('');
	const [currentSheet, setCurrentSheet] = useState<CheatSheetData>(condaSheet);
	const uiChoices = sheets.map((i) => {
		const clsNames =
			i.title === currentSheet.title
				? 'sheetButton sheetButtonSelected'
				: 'sheetButton';
		return (
			<div className={clsNames} onClick={(e) => setCurrentSheet(i)}>
				{i.button}
			</div>
		);
	});

	const uiTable = currentSheet.items
		.filter((v) => {
			if (search === '') return true;
			return (
				v.command.toUpperCase().includes(search.toUpperCase()) ||
				v.description.toUpperCase().includes(search.toUpperCase())
			);
		})
		.map((i) => {
			return (
				<div className='itemrow'>
					<div className='item-command'>{i.command}</div>
					<div className='item-description'>{i.description}</div>
				</div>
			);
		});
	return (
		<>
			<div className='cheatChoicePanel'>{uiChoices}</div>
			<div className='panel'>
				<div className='item-headline'>
					<div>
						<h2>{currentSheet.title}</h2>
					</div>
					<div className='item-search'>
						<input
							type='text'
							value={search}
							autoFocus
							onChange={(e) => setsearch(e.target.value)}
							placeholder='Type search string here'
						></input>
					</div>
					<div>
						<a href={currentSheet.officialDocumentation}>
							Official Documentation
						</a>
					</div>
				</div>
				{uiTable}
			</div>
		</>
	);
};
